import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { AuthenticationService } from "../shared/services/authentication.service";

@Injectable()
export class AuthGuard  {
  constructor(public authService: AuthenticationService, public router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      // First check if the user is succesfully logged in. Redirect to
      // login if that is not the case.
      tap((canActivate) => canActivate || this.authService.Login(state.url)),
      // After that, check if a profile could be resolved. Show an error
      // if that is not the case.
      switchMap((_) => this.authService.profile$),
      map((profile) => Boolean(profile)),
      tap(
        (hasProfile) => hasProfile || this.router.navigateByUrl("/errors/403")
      )
    );
  }
}
